import { FC, useEffect, useMemo, useRef, useState } from "react";
import { isTeamChannel, ModerationType } from "shared/pages/teams/const/ModerationTypes";
import { GroupAPI, Lang, Team, TeamAPI } from "@brg/api";
import { useTranslation } from "react-i18next";

const getPrefix = (lang: string) => {
    if (lang === 'ru') {
        return {
            coursePrefix: 'Программа: ',
            groupPrefix: 'Группа: '
        }
    }
    else {
        return {
            coursePrefix: 'Programm: ',
            groupPrefix: 'Group: '
        }
    }
}

export const useAutoChannelName = (team: any, disable: boolean)  => {
    const {i18n:{language}} = useTranslation();
    const langRef = useRef<any>(null);
    const hasRequest = useRef<any>(null);
    const { isChannel, channelType} = isTeamChannel(team?.moderationType);
    const [names, setNames] = useState({
        courseName: '',
        groupName: '',
        coursePrefix: '',
        groupPrefix: '',
        channelLink: ''
    })

    const calcDefaultChannelName = () => {
        const { lmsCourseId, lmsGroupId, lmsCourseName, lmsCourseRoute, lmsGroupName } = team?.additionalInfo;

        const parseLmsName = lmsCourseName ? JSON.parse(lmsCourseName || '') : ''
        const parseGroupName = lmsGroupName ? JSON.parse(lmsGroupName || '') : ''

        const translatedLmsName = Lang(parseLmsName, language) || '';
        const translatedGroupName = Lang(parseGroupName, language) || ''
        const lmsRoute = lmsCourseRoute || process.env.REACT_APP_URL_HSEDESIGN_LMS + '/teams/' + lmsCourseId

        setNames({
            courseName: translatedLmsName,
            groupName: translatedGroupName,
            channelLink: lmsRoute,
            ...getPrefix(language)
        })

    }
    useEffect(() => {
        if (!hasRequest.current && team && !disable) {
            calcDefaultChannelName()
        }
    } , [hasRequest, team, disable])

    useEffect(() => {
        if (langRef.current !== langRef) {
            hasRequest.current = false
        }
    } , [language, langRef])


    if (channelType !== ModerationType.ChannelGroupOrCourse || !team || disable) {
        return null;
    }

    return names
}import { FC, useEffect, useMemo, useRef, useState } from "react";
import { isTeamChannel, ModerationType } from "shared/pages/teams/const/ModerationTypes";
import { GroupAPI, Lang, Team, TeamAPI } from "@brg/api";
import { useTranslation } from "react-i18next";

const getPrefix = (lang: string) => {
    if (lang === 'ru') {
        return {
            coursePrefix: 'Программа: ',
            groupPrefix: 'Группа: '
        }
    }
    else {
        return {
            coursePrefix: 'Programm: ',
            groupPrefix: 'Group: '
        }
    }
}

export const useAutoChannelName = (team: any, disable: boolean)  => {
    const {i18n:{language}} = useTranslation();
    const langRef = useRef<any>(null);
    const hasRequest = useRef<any>(null);
    const { isChannel, channelType} = isTeamChannel(team?.moderationType);
    const [names, setNames] = useState({
        courseName: '',
        groupName: '',
        coursePrefix: '',
        groupPrefix: '',
        channelLink: ''
    })

    const calcDefaultChannelName = () => {
        const { lmsCourseId, lmsGroupId, lmsCourseName, lmsCourseRoute, lmsGroupName } = team?.additionalInfo;

        const parseLmsName = lmsCourseName ? JSON.parse(lmsCourseName || '') : ''
        const parseGroupName = lmsGroupName ? JSON.parse(lmsGroupName || '') : ''

        const translatedLmsName = Lang(parseLmsName, language) || '';
        const translatedGroupName = Lang(parseGroupName, language) || ''
        const lmsRoute = lmsCourseRoute || process.env.REACT_APP_URL_HSEDESIGN_LMS + '/teams/' + lmsCourseId

        setNames({
            courseName: translatedLmsName,
            groupName: translatedGroupName,
            channelLink: lmsRoute,
            ...getPrefix(language)
        })

    }
    useEffect(() => {
        if (!hasRequest.current && team && !disable) {
            calcDefaultChannelName()
        }
    } , [hasRequest, team, disable])

    useEffect(() => {
        if (langRef.current !== langRef) {
            hasRequest.current = false
        }
    } , [language, langRef])


    if (channelType !== ModerationType.ChannelGroupOrCourse || !team || disable) {
        return null;
    }

    return names
}